import { Link } from "react-router-dom";
import { useState } from "react";
import { EnvelopeSimple, Phone, LinkedinLogo } from "@phosphor-icons/react";
import LegalModal from "@/components/LegalModal";

export default function Footer() {
  const [legalOpen, setLegalOpen] = useState(false);

  return (
    <footer className="bg-navy-deep text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src="/logo-cropped.png"
                alt="MP Advisory"
                className="block h-14 sm:h-16 w-auto rounded-md"
              />
            </div>
            <p className="text-white/65 leading-relaxed max-w-md text-[15px]">
              Cabinet indépendant spécialisé en recrutement Sales & IT.
              Des rencontres humaines, des opportunités durables.
            </p>
            <div className="accent-line mt-8" />
          </div>

          {/* Nav */}
          <div className="md:col-span-3">
            <p className="eyebrow text-purple-accent mb-5">Liens rapides</p>
            <ul className="space-y-3 text-[15px] text-white/70">
              <li><Link to="/" className="hover:text-white transition" data-testid="footer-link-home">Accueil</Link></li>
              <li><Link to="/candidats" className="hover:text-white transition" data-testid="footer-link-candidates">Candidats</Link></li>
              <li><Link to="/entreprises" className="hover:text-white transition" data-testid="footer-link-companies">Entreprises</Link></li>
              <li><Link to="/formulaire" className="hover:text-white transition" data-testid="footer-link-form">Formulaire</Link></li>
              <li><Link to="/contact" className="hover:text-white transition" data-testid="footer-link-contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <p className="eyebrow text-purple-accent mb-5">Contact</p>
            <ul className="space-y-4 text-[15px] text-white/70">
              <li className="flex items-start gap-3">
                <EnvelopeSimple size={18} weight="duotone" className="mt-0.5 text-purple-accent shrink-0" />
                <a href="mailto:rh@mpadvisory.fr" className="hover:text-white transition" data-testid="footer-email">rh@mpadvisory.fr</a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={18} weight="duotone" className="mt-0.5 text-purple-accent shrink-0" />
                <a href="tel:+33683175127" className="hover:text-white transition" data-testid="footer-phone">06 83 17 51 27</a>
              </li>
              <li className="flex items-start gap-3">
                <LinkedinLogo size={18} weight="duotone" className="mt-0.5 text-purple-accent shrink-0" />
                <a
                  href="https://www.linkedin.com/in/magalie-pichon-25247a102/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                  data-testid="footer-linkedin"
                >
                  Magalie Pichon
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4 text-sm text-white/50">
          <p>© 2026 MP Advisory. Tous droits réservés.</p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
            <button
              type="button"
              onClick={() => setLegalOpen(true)}
              data-testid="footer-legal-link"
              className="hover:text-white transition text-left"
            >
              Documents légaux
            </button>
            <p className="font-serif italic">Des rencontres humaines, des opportunités durables.</p>
          </div>
        </div>
      </div>
      <LegalModal open={legalOpen} onOpenChange={setLegalOpen} />
    </footer>
  );
}
